export { OutstandingBobbyDeclarationsComponent } from './outstanding-bobby-declarations.component';